export const UIComponent = {
    TimeSlider: "TimeSlider",
    Legend: "Legend",
    CountriesSearcher: "CountriesSearcher",
    StatsBar: "StatsBar",
    TabMenu: "TabMenu",
    Zoom: "Zoom"
}